import CONSTANTS from '@tcp/core/src/components/common/molecules/SearchBar/SearchBar.constants';
import { extractAttributeValue } from '@tcp/core/src/utils/badge.util';
import {
  getViewportInfo,
  internalCampaignProductAnalyticsList,
  getQueryParamsFromUrl,
  getBrandInCaps,
  formatPromotionMessage,
  fireEnhancedEcomm,
  getSessionStorage,
  removeSessionStorage,
  setSessionStorage,
} from '@tcp/core/src/utils/index';
import { getGAPageName } from '@tcp/core/src/utils/utils.web';
import { setProp } from '@tcp/core/src/analytics/utils';
import {
  getTopRatedBadge,
  getBestSellerBadge,
  getMostFavoriteBadge,
  getOriginalPrice,
} from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/views/ProductGridItem.util';
import {
  TOP_RATED_ANALYTICS_STRING,
  BEST_SELLER_ANALYTICS_STRING,
  MOST_FAVORITED_ANALYTICS_STRING,
} from '@tcp/core/src/constants/badge.constants';
import { breadCrumbStr } from '../../ProductListing/container/PlpCarousel.utils';
import pushEventToAdobeAnalytics from '../../../../../adobeAnalytics/adobe.utils';

export const getProductCategory = (breadCrumbs) => {
  const apparelText = 'apparel';
  if (!breadCrumbs || !breadCrumbs.length) return apparelText;

  let category = '';
  const formattedCategory = breadCrumbs.map(
    (listing) => listing.displayName && listing.displayName.toLowerCase()
  );

  if (!formattedCategory || !formattedCategory.length) return apparelText;

  if (formattedCategory.includes('accessories')) {
    category = 'accessories';
  } else if (formattedCategory.includes('shoes')) {
    category = 'shoes';
  } else {
    category = apparelText;
  }
  return category;
};

const getPageNavigationText = (isDesktop, isNewNavigationImagesEnabled) => {
  if (isDesktop) {
    const categoryPillClicked = getSessionStorage('categoryPillClicked');
    if (categoryPillClicked) {
      return '';
    }
    if (isNewNavigationImagesEnabled) {
      return 'topmenu-withimage-';
    }
    return 'topmenu-';
  }
  return isNewNavigationImagesEnabled ? 'hamburger-withimage-' : 'hamburger-';
};

const getIsTopRatedOrBestSeller = ({ badge, category, callback, key, returnValue, backAB }) => {
  if (badge && category && callback) {
    const badge1 = {
      [key]: {
        categories: badge,
      },
    };
    const [categoryId] = category?.split('|');
    const categoryIdToCheck = categoryId.trim();
    const isTopRatedOrBestSeller = callback(badge1, true, categoryIdToCheck);
    return !backAB && isTopRatedOrBestSeller ? returnValue : '';
  }
  return '';
};

export const getAnalyticsFormatedProductsEE = ({
  paginatedProducts,
  breadcrumbs,
  currency,
  isTopRatedBackAbEnabled,
  isBestSellerBackAbEnabled,
  isHideOriginalPriceAndMarchantTagEnabled,
  isMostFavoritedBadgeEnabled,
  promotionsData = {},
}) => {
  const formattedCategory =
    breadcrumbs &&
    breadcrumbs.map((listing) => listing.displayName && listing.displayName.toLowerCase());
  const resultingArray = [];
  const brand = getBrandInCaps();
  let category = '';
  if (breadcrumbs && breadcrumbs.length > 0) {
    const { categoryId, displayName } = breadcrumbs[breadcrumbs.length - 1];
    category = `${categoryId} | ${displayName}`;
  }
  let index = 0;
  paginatedProducts?.forEach((product) => {
    if (product.isTitle) {
      const { id, name } = product;
      category = `${id} | ${name}`;
    } else {
      const {
        style_partno: productId,
        min_offer_price: price,
        min_list_price: listPrice,
        low_offer_price: extPrice,
        prodpartno: productPartNumber,
        tcp_promotion_id: TCPPromotionID,
      } = product;
      const topRatedBadge = extractAttributeValue(product, 'topRatedCategories');
      const bestSellerBadge = extractAttributeValue(product, 'FeaturedCategories');
      const mostFavoritedBadge = extractAttributeValue(product, 'mostFavoritedCategories');
      const isTopRated = getIsTopRatedOrBestSeller({
        badge: topRatedBadge,
        category,
        callback: getTopRatedBadge,
        backAB: isTopRatedBackAbEnabled,
        key: 'topRatedBadge',
        returnValue: TOP_RATED_ANALYTICS_STRING,
      });
      const isBestSeller = getIsTopRatedOrBestSeller({
        badge: bestSellerBadge,
        category,
        callback: getBestSellerBadge,
        backAB: isBestSellerBackAbEnabled,
        key: 'isBestSeller',
        returnValue: BEST_SELLER_ANALYTICS_STRING,
      });
      const isMostFavorited = getIsTopRatedOrBestSeller({
        badge: mostFavoritedBadge,
        category,
        callback: getMostFavoriteBadge,
        backAB: isMostFavoritedBadgeEnabled,
        key: 'mostFavoritedBadge',
        returnValue: MOST_FAVORITED_ANALYTICS_STRING,
      });
      const originalPrice = getOriginalPrice({
        hardMarkDown: product?.is_hard_mark_enable,
        isHideOriginalPriceAndMarchantTagEnabled,
        listPrice,
        currency,
      });

      resultingArray[index] = {
        id: productId,
        price,
        category,
        listPrice,
        extPrice,
        dimension35: brand,
        metric92: '1',
        dimension63: `${price}${currency} ${originalPrice}`,
        dimension67: price < listPrice ? 'on sale' : `full price`,
        dimension80: category,
        dimension83: formattedCategory && formattedCategory[0],
        dimension89: productId,
        dimension100: index + 1,
        dimension56: promotionsData[TCPPromotionID]
          ? formatPromotionMessage(promotionsData, TCPPromotionID)
          : '',
        dimension108: isTopRated,
        dimension109: isBestSeller,
        dimension139: isMostFavorited,
        productPartNumber,
      };
      index += 1;
    }
  });
  return resultingArray;
};
const getAnalyticsFormatedProducts = (products, breadCrumbNames) => {
  if (products.length > 0) {
    return products.map(
      (
        {
          style_partno: id,
          prodpartno: colorId,
          product_name: name,
          min_offer_price: price,
          min_list_price: listPrice,
          low_offer_price: extPrice,
        },
        index
      ) => {
        let type = '';
        if (breadCrumbNames.length && breadCrumbNames.includes('accessories')) {
          type = 'accessories';
        } else if (breadCrumbNames.includes('shoes')) {
          type = 'shoes';
        } else {
          type = 'apparel';
        }
        return {
          id,
          colorId,
          name,
          price,
          listPrice,
          extPrice,
          position: index + 1,
          type,
          pricingState: price < listPrice ? 'on sale' : 'full price',
        };
      }
    );
  }
  return [];
};
const getFilterCount = (appliedFilters = {}) => {
  let count = 0;
  const filterKeys = Object.keys(appliedFilters);
  if (Array.isArray(filterKeys) && filterKeys.length > 0) {
    filterKeys.forEach((key) => {
      count += appliedFilters[key].length;
    });
  }
  return count;
};
const isViaPromoFilterModule = (router = {}) => {
  const queryParams = getQueryParamsFromUrl(router && router.asPath);
  return queryParams && queryParams.viaModule && queryParams.viaModule[0] === 'promoFilter';
};
export const getIcidValue = (path) => {
  const internalcId = 'icid';
  const queryParams = getQueryParamsFromUrl(path);
  const icidObj = queryParams[internalcId];
  return icidObj && icidObj.length ? icidObj[0] : null;
};

export const getIcidWithPromoFilterSlot = (router, breadCrumbs, pageType) => {
  const viaPromoFilter = isViaPromoFilterModule(router);
  if (!viaPromoFilter) return null;
  if (typeof window !== 'undefined') {
    const storeSlot = getSessionStorage('carouselItem');
    const slotId = storeSlot ? storeSlot.split('_')?.[0] : 'na';
    const cats = breadCrumbStr(breadCrumbs);
    const campaignName = '_na';
    removeSessionStorage('carouselItem');
    return `${pageType}_${slotId}${cats}${campaignName}`;
  }
  return null;
};

export const getCategoryListingPageTrackData = ({
  breadcrumbs,
  paginatedProducts,
  totalProductsCount,
  isNewNavigationImagesEnabled,
  storeId = '',
  appliedFilters,
  router,
  icid,
  appliedSort: sort,
  shopall,
}) => {
  const breadCrumbNames = breadcrumbs.map((breadCrumb) => breadCrumb.displayName.toLowerCase());
  const pageName = `browse:${breadCrumbNames.join(':')}`;
  let listingSubCategory = breadCrumbNames[2];
  if (breadCrumbNames.length < 3) {
    listingSubCategory = null;
  }
  let customEvents = ['event91', 'event92', 'event82', 'event80'];
  const searchType = CONSTANTS.NAVIGATION_CATEGORY;
  const { isDesktop } = getViewportInfo() || {};
  let pageNavigationText = getPageNavigationText(isDesktop, isNewNavigationImagesEnabled);
  pageNavigationText = `${pageNavigationText}${breadCrumbNames.join('-')}`;
  const categoryPillClicked = getSessionStorage('categoryPillClicked');
  if (categoryPillClicked) {
    pageNavigationText = `categorypill-${pageNavigationText}`;
    setSessionStorage({ key: 'categoryPillClicked', value: '' });
  }
  const supressProps = ['eVar94'];
  let internalCampaignId = '';
  let promoFilterCategoryTrail = '';
  const products = getAnalyticsFormatedProducts(paginatedProducts, breadCrumbNames);
  const filterCount = getFilterCount(appliedFilters);
  const viaPromoFilter = isViaPromoFilterModule(router);
  const pageSearchText = '';

  setProp('prop23', `${breadCrumbNames.join(':')}`);
  if (sort) {
    pageNavigationText = '';
    customEvents = ['event91', 'event92', 'event80'];
  }

  if (shopall) {
    pageNavigationText = `${pageNavigationText}-${shopall}`;
  }

  if (filterCount) {
    setProp('eVar22', 'browser');
  }

  if (icid) {
    internalCampaignId = icid;
  }

  if (sort || filterCount) {
    supressProps.push('eVar97');
  }

  if (viaPromoFilter) {
    customEvents.push('event180');
    promoFilterCategoryTrail = breadCrumbNames.join('>');
  }

  return {
    pageName,
    pageSection: `browse:${breadCrumbNames[0]}`,
    pageSubSection: pageName,
    internalCampaignIdList: internalCampaignProductAnalyticsList(),
    pageType: 'browse',
    listingCount: products ? totalProductsCount : '',
    customEvents,
    pageSearchType: searchType,
    departmentList: breadCrumbNames[0],
    categoryList: breadCrumbNames[1],
    listingSubCategory,
    pageNavigationText,
    pageShortName: '',
    supressProps,
    internalCampaignId,
    promoFilterCategoryTrail,
    storeId,
    products,
    filterCount,
    totalProductsCount,
    pageSearchText,
  };
};

export const getHorizontalCategoryPageTrackData = (
  breadCrumbs,
  isNewNavigationImagesEnabled,
  router,
  icid,
  storeId,
  paginatedProducts,
  aplp
) => {
  const breadCrumbNames = breadCrumbs?.map((breadCrumb) => breadCrumb.displayName.toLowerCase());
  const pageName = `browse-${aplp ? 'aplp' : 'hlp'}:${breadCrumbNames.join(':')}`;
  let listingSubCategory = breadCrumbNames[2];
  if (breadCrumbNames.length < 3) {
    listingSubCategory = null;
  }
  const customEvents = aplp ? ['event91', 'event82'] : ['event91', 'event92', 'event82', 'event80'];
  const searchType = CONSTANTS.NAVIGATION_CATEGORY;
  const { isDesktop } = getViewportInfo() || {};
  let pageNavigationText = getPageNavigationText(isDesktop, isNewNavigationImagesEnabled);
  pageNavigationText = `${pageNavigationText}${breadCrumbNames.join('-')}`;
  const supressProps = ['eVar94'];
  let internalCampaignId = '';
  let promoFilterCategoryTrail = '';
  const viaPromoFilter = isViaPromoFilterModule(router);
  const pageSearchText = '';
  const products = getAnalyticsFormatedProducts(paginatedProducts, breadCrumbNames);

  setProp('prop23', `${breadCrumbNames.join(':')}`);

  if (icid) {
    internalCampaignId = icid;
  }

  if (viaPromoFilter) {
    customEvents.push('event180');
    promoFilterCategoryTrail = breadCrumbNames.join('>');
  }

  return {
    pageName,
    pageSection: `browse-${aplp ? 'aplp' : 'hlp'}:${breadCrumbNames[0]}`,
    pageSubSection: pageName,
    internalCampaignIdList: internalCampaignProductAnalyticsList(),
    pageType: `browse-${aplp ? 'aplp' : 'hlp'}`,
    customEvents,
    pageSearchType: searchType,
    departmentList: breadCrumbNames[0],
    categoryList: breadCrumbNames[1],
    listingSubCategory,
    pageNavigationText,
    pageShortName: '',
    storeId,
    supressProps,
    products,
    internalCampaignId,
    promoFilterCategoryTrail,
    pageSearchText,
  };
};

export const trackAnalyticsChange = ({ paginatedProducts, appliedFilters }) => {
  let currentProducts = '';
  const filterCount = getFilterCount(appliedFilters);
  let prodFound = false;
  const prodLen = paginatedProducts.length;
  let i = 0;
  while (!prodFound && i < prodLen) {
    currentProducts = paginatedProducts[i]?.product_name || '';
    if (currentProducts) {
      prodFound = true;
    }
    i += 1;
  }

  return {
    currentProducts,
    filterCount,
  };
};

export const getSearchAnalyticsData = (
  categoryListingPageTrackerData,
  asPath,
  productsFormattedEE,
  totalProductsCount
) => {
  const searchRedirectObj = JSON.parse(getSessionStorage('searchRedirect')) || {};
  if (searchRedirectObj?.isDone && searchRedirectObj?.searchTerm) {
    const queryParamPage = asPath?.split('page=')?.[1];
    let selectedPage = queryParamPage || 1;
    selectedPage = selectedPage ? parseInt(selectedPage, 10) : 1;
    const pageName = 'search:results';
    pushEventToAdobeAnalytics('internal_search', {
      searchedText: searchRedirectObj.searchTerm,
      searchType: 'keyword',
      totalProductsCount,
    });
    return {
      products: productsFormattedEE,
      pageSearchType: 'internal search',
      pageSearchText: searchRedirectObj.searchTerm,
      pageType: 'search',
      pageName,
      pageSection: 'search',
      pageSubSection: 'search',
      searchType: 'keyword',
      customEvents: ['event20', 'event78'],
      listingCount: totalProductsCount,
      listingSortList: 'sort=recommended',
      slpPage_cd78: `${searchRedirectObj.searchTerm}|${selectedPage}`,
    };
  }
  return categoryListingPageTrackerData;
};

export const QVEcommerceCall = ({
  tileData,
  isTopRatedBackAbEnabled,
  isBestSellerBackAbEnabled,
  tileBadges,
  isMostFavoritedBadgeEnabled,
}) => {
  const currentSiteBrand = getBrandInCaps();
  const args = {
    eventName: 'productDetail',
    eventType: 'detail',
    pageName: 'plp',
    eventLabel: 'quick view product detail',
    productsObj: [
      {
        id: tileData.productid,
        price: tileData.min_offer_price,
        name: tileData.product_name,
        brand: currentSiteBrand,
        dimension20: tileData.productid,
        dimension21: 'plp',
        dimension35: currentSiteBrand,
        dimension66: tileData?.dimension66 || '',
        dimension89: tileData.productid,
        dimension108:
          !isTopRatedBackAbEnabled && tileBadges?.topRatedBadge ? TOP_RATED_ANALYTICS_STRING : '',
        dimension109:
          !isBestSellerBackAbEnabled && tileBadges?.bestSellerBadge
            ? BEST_SELLER_ANALYTICS_STRING
            : '',
        dimension139:
          !isMostFavoritedBadgeEnabled && tileBadges?.mostFavoritedBadge
            ? MOST_FAVORITED_ANALYTICS_STRING
            : '',
      },
    ],
  };
  fireEnhancedEcomm(args);
};

export const callAnalyticsOnAddToBagclick = ({
  productId,
  page,
  acrossBrandApiCalled,
  alternateBrandsShown,
  searchQuery,
  offerPrice,
  productName,
}) => {
  if (!page) return;
  const currentSiteBrand = getBrandInCaps();
  const cd122 = acrossBrandApiCalled
    ? { dimension122: `${currentSiteBrand}>${alternateBrandsShown?.toUpperCase()}|null search` }
    : '';
  const args = {
    eventName: 'productDetail',
    eventType: 'detail',
    pageName: page,
    eventLabel: 'quick view product detail',
    productsObj: [
      {
        id: productId,
        price: offerPrice,
        name: productName,
        brand: currentSiteBrand,
        category: searchQuery,
        dimension20: productId,
        dimension21: page,
        dimension35: currentSiteBrand,
        dimension80: searchQuery,
        dimension89: productId,
        dimension92: '',
        dimension2: 'browse',
        metric50: '1',
        ...cd122,
      },
    ],
  };
  pushEventToAdobeAnalytics('product_quick_view', args?.productsObj?.[0]);
  fireEnhancedEcomm(args);
};

export const updateGoogleAnalyticsData = ({
  shouldTriggerAnalyticsCall,
  page,
  offerPrice,
  listPrice,
  searchQuery,
  position,
  currency,
  isHideOriginalPriceAndMarchantTagEnabled,
  tileData,
}) => {
  const {
    product_name: productName,
    is_hard_mark_enable: hardMarkDown,
    TCPColor,
    auxdescription: auxDescription,
    productid: productId,
  } = tileData;

  if (!shouldTriggerAnalyticsCall) {
    return;
  }
  const color = auxDescription || TCPColor;
  const currentSiteBrand = getBrandInCaps();
  const originalPrice = getOriginalPrice({
    hardMarkDown,
    isHideOriginalPriceAndMarchantTagEnabled,
    listPrice,
    currency,
    addWhiteSpace: true,
  });

  const args = {
    eventName: 'productclick',
    eventAction: 'Product Click',
    eventType: 'click',
    pageName: getGAPageName(),
    currCode: currency,
    eventLabel: 'Product detail',
    productsObj: [
      {
        name: productName,
        id: productId,
        price: offerPrice,
        brand: currentSiteBrand,
        category: searchQuery,
        variant: color,
        position: position + 1,
        dimension80: searchQuery,
        dimension67: offerPrice < listPrice ? 'on sale' : 'full price',
        dimension89: productId,
        dimension100: position + 1,
        dimension63: `${offerPrice} ${currency}: ${originalPrice}`,
        dimension77: color,
        dimension35: currentSiteBrand,
        dimension92: '',
        dimension21: page,
      },
    ],
  };
  pushEventToAdobeAnalytics('product_click', args?.productsObj?.[0]);
  fireEnhancedEcomm(args);
};
